/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import Select from 'react-select'
import { FilterModal } from './styles'
import { IoCloseCircleSharp } from 'react-icons/io5'

interface FilterProps {
  options: {
    distribuidores: any[]
    anos: any[]
    meses: any[]
    semanas?: any[]
    cidades: any[]
    clientes: any[]
    marcas: any[]
    categorias: any[]
  }
  filters: any
  setFilters: React.Dispatch<React.SetStateAction<any>>
  closeFilter: () => void
}

export default function Filter({ options, filters, setFilters, closeFilter }: FilterProps) {
  // Handler para os filtros que continuam Múltiplos (Distribuidor, Cliente, etc)
  const handleChangeMulti = (field: string) => (selectedOptions: any) => {
    setFilters((prev: any) => ({
      ...prev,
      [field]: selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [],
    }))
  }

  const customStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: 40,
      borderRadius: '27px',
      border: 'none',
      boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
      cursor: 'pointer',
      padding: '0 5px',
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '12px',
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 999999999999 }),
    menu: (base: any) => ({
      ...base,
      borderRadius: '10px',
      overflow: 'hidden',
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '12px',
    }),
    option: (base: any) => ({ ...base, fontFamily: "'Montserrat', sans-serif" }),
    placeholder: (base: any) => ({ ...base, fontFamily: "'Montserrat', sans-serif" }),
    multiValue: (base: any) => ({
      ...base,
      fontFamily: "'Montserrat', sans-serif",
      borderRadius: '4px',
    }),
    multiValueLabel: (base: any) => ({ ...base, fontFamily: "'Montserrat', sans-serif" }),
  }

  const handleClear = () => {
    setFilters({
      distribuidores: [],
      anos: [],
      meses: [],
      semanas: [],
      startDate: '',
      endDate: '',
      cidades: [],
      clientes: [],
      marcas: [],
      categorias: [],
    })
  }

  const labelStyle: React.CSSProperties = {
    color: '#002b80',
    marginTop: 10,
    fontSize: '12px',
    fontWeight: 'bold',
    marginBottom: '5px',
    display: 'block',
    fontFamily: "'Montserrat', sans-serif",
  }

  return (
    <FilterModal>
      <div className='header'>
        Filtros avançados
        <button
          onClick={() => closeFilter()}
          type='button'
          style={{
            background: 'transparent',
            position: 'absolute',
            right: 5,
            fontSize: 24,
            zIndex: 9999999999,
          }}
        >
          <IoCloseCircleSharp />
        </button>
      </div>

      <div
        className='body'
        style={{
          padding: 0,
          overflow: 'hidden',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <label style={labelStyle}>Distribuidor</label>
          <Select
            isMulti
            options={options.distribuidores}
            styles={customStyles}
            placeholder='Selecione...'
            menuPortalTarget={document.body}
            menuPosition='fixed'
            onChange={handleChangeMulti('distribuidores')}
            value={options.distribuidores.filter((opt) =>
              filters.distribuidores.includes(opt.value),
            )}
          />

          {options.semanas && options.semanas.length > 0 && (
            <>
              <label style={labelStyle}>Semanas</label>
              <Select
                isMulti
                options={options.semanas}
                styles={customStyles}
                placeholder='Selecione as semanas...'
                menuPortalTarget={document.body}
                menuPosition='fixed'
                onChange={handleChangeMulti('semanas')}
                value={options.semanas.filter((opt) =>
                  (filters.semanas || []).includes(opt.value),
                )}
              />
            </>
          )}

          <label style={labelStyle}>Cidades</label>
          <Select
            isMulti
            options={options.cidades}
            styles={customStyles}
            placeholder='Selecione...'
            menuPortalTarget={document.body}
            menuPosition='fixed'
            onChange={handleChangeMulti('cidades')}
            value={options.cidades.filter((opt) => filters.cidades.includes(opt.value))}
          />

          <label style={labelStyle}>Clientes</label>
          <Select
            isMulti
            options={options.clientes}
            styles={customStyles}
            placeholder='Selecione...'
            menuPortalTarget={document.body}
            menuPosition='fixed'
            onChange={handleChangeMulti('clientes')}
            value={options.clientes.filter((opt) => filters.clientes.includes(opt.value))}
          />

          <label style={labelStyle}>Marcas</label>
          <Select
            isMulti
            options={options.marcas}
            styles={customStyles}
            placeholder='Selecione...'
            menuPortalTarget={document.body}
            menuPosition='fixed'
            onChange={handleChangeMulti('marcas')}
            value={options.marcas.filter((opt) => filters.marcas.includes(opt.value))}
          />

          <label style={labelStyle}>Categorias</label>
          <Select
            isMulti
            options={options.categorias}
            styles={customStyles}
            placeholder='Selecione...'
            menuPortalTarget={document.body}
            menuPosition='fixed'
            onChange={handleChangeMulti('categorias')}
            value={options.categorias.filter((opt) => filters.categorias.includes(opt.value))}
          />

          <div
            className='button'
            style={{
              padding: '15px 20px',
              backgroundColor: '#fff',
              borderTop: '1px solid #eaeaea',
              margin: 0,
              boxShadow: '0px -4px 10px rgba(0,0,0,0.05)',
              zIndex: 10,
              marginTop: '10px',
            }}
          >
            <button type='button' className='cancel' onClick={handleClear}>
              Limpar
            </button>
          </div>
        </div>
      </div>
    </FilterModal>
  )
}
